import { Empty } from "antd";
import { IoChatbubbleEllipses, IoHeartSharp, IoPlay } from "react-icons/io5";
import { formatCnt } from "../../../utils/formatCnt";
import test_img from "../../../../images/32637972_7843794.jpg";

export const YoutubeContents = ({ youtube }) => {
  const contents = youtube || [];

  const handleOpenVideo = (videoUrl) => {
    if (!videoUrl) return;
    window.open(videoUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      {contents.length > 0 ? (
        <>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {contents.map((content) => (
              <div
                key={content.video_id}
                className="group overflow-hidden rounded-[24px] border border-[#ebeff5] text-left shadow-[0_8px_24px_rgba(15,23,42,0.06)] transition-shadow duration-300 hover:shadow-[0_18px_40px_rgba(15,23,42,0.12)]"
                onClick={() => handleOpenVideo(content.video)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleOpenVideo(content.video);
                  }
                }}
                role="button"
                tabIndex={0}
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={content.thumbnail || test_img}
                    alt="유튜브 썸네일"
                    className="absolute inset-0 h-full w-full scale-[1.01] object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                    onError={(e) => {
                      e.currentTarget.src = test_img;
                    }}
                  />
                </div>
                <div className="text-[14px] md:text-[12px] text-[#595959] space-y-1 p-4">
                  <p className="flex items-center gap-1.5 m-0 truncate">
                    <IoPlay className="text-[#13C2C2]" />
                    <span>{formatCnt(content.view_count || 0)}</span>
                  </p>
                  <p className="flex items-center gap-1.5 m-0 truncate">
                    <IoHeartSharp className="text-[#FF4D4F]" />
                    <span>{formatCnt(content.like_count || 0)}</span>
                  </p>
                  <p className="flex items-center gap-1.5 m-0 truncate">
                    <IoChatbubbleEllipses className="text-[#1890FF]" />
                    <span>{formatCnt(content.comment_count || 0)}</span>
                  </p>
                  <p className="text-[14px] md:text-[12px] mt-[6px] md:mt-[8px] mb-0 text-[#1890FF] overflow-hidden line-clamp-2 font-medium min-h-[16px] md:min-h-[20px]">
                    {content.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <Empty
          description={
            <div className="text-[14px] text-[#666]">
              브랜드 영상이 없습니다.
            </div>
          }
        />
      )}
    </>
  );
};
